import React from "react";
import { useHasTopmostBlockingOverlay } from "@app/overlay/hooks/useHasTopmostBlockingOverlay";
import { useScannerContext } from "./ScannerContext";

/**
 * Синхронизирует overlay stack с глобальной паузой scanner registry.
 *
 * Монтируется в `AppProviders` **внутри** `OverlayProvider` и **внутри** `ScannerProvider`:
 * читает blocking overlay из overlay context и вызывает `setGlobalSuppress` scanner layer.
 */
export const ScannerOverlaySuppressBridge: React.FC = () => {
    const suppressed = useHasTopmostBlockingOverlay();
    const { setGlobalSuppress } = useScannerContext();

    React.useEffect(() => {
        setGlobalSuppress(suppressed);
    }, [setGlobalSuppress, suppressed]);

    return null;
};
